import React, { useState } from 'react';
import { useAdminAuth } from '../context/AdminAuthContext';

// ساختار درختی منو - بعداً گزینه‌های جدید همینجا اضافه می‌شن
const MENU_TREE = [
  {
    id: 'dashboard',
    title: 'داشبورد',
    icon: 'dashboard',
    children: [
      { id: 'dashboard-overview', title: 'گزارش کلی', icon: 'insights' }
    ]
  },
  {
  id: 'settings',
  title: 'تنظیمات سایت',
  icon: 'settings',
  children: [
    { id: 'settings-general', title: 'قیمت دانلود تکی', icon: 'attach_money' }
  ]
},
{
  id: 'blog',
  title: 'مدیریت وبلاگ',
  icon: 'article',
  children: [
    { id: 'blog-posts', title: 'لیست مقالات', icon: 'list' }
  ]
},
{
  id: 'requests',
  title: 'درخواست‌های فایل',
  icon: 'mark_email_unread',
  children: [
    { id: 'requests-list', title: 'لیست درخواست‌ها', icon: 'list' }
  ]
},
  {
    id: 'users',
    title: 'مدیریت کاربران',
    icon: 'people',
    children: [
      { id: 'users-list', title: 'لیست کاربران', icon: 'list' }
    ]
  },
  {
    id: 'products',
    title: 'مدیریت محصولات',
    icon: 'inventory_2',
    children: [
      { id: 'products-types', title: 'نوع محصولات', icon: 'category' },
      { id: 'products-brands', title: 'برندها', icon: 'branding_watermark' },
      { id: 'products-files', title: 'فایل‌ها', icon: 'folder' }
    ]
  },
  {
    id: 'plans',
    title: 'پلن‌های عضویت',
    icon: 'workspace_premium',
    children: [
      { id: 'plans-list', title: 'لیست پلن‌ها', icon: 'list' }
    ]
  }
];

export const AdminSidebar = ({ activePage, onNavigate }) => {
  const { admin, logout } = useAdminAuth();
  const [expandedGroups, setExpandedGroups] = useState(['dashboard']);

  const toggleGroup = (groupId) => {
    setExpandedGroups((prev) =>
      prev.includes(groupId) ? prev.filter((id) => id !== groupId) : [...prev, groupId]
    );
  };

  return (
    <div
      dir="rtl"
      style={{
        width: 260,
        minHeight: '100vh',
        backgroundColor: '#1c2529',
        borderLeft: '1px solid #37474F',
        display: 'flex',
        flexDirection: 'column'
      }}
    >
      {/* هدر */}
      <div style={{ padding: '20px 16px', borderBottom: '1px solid #37474F', display: 'flex', alignItems: 'center' }}>
        <div
          className="w3-circle"
          style={{
            width: 40,
            height: 40,
            backgroundColor: '#2980b9',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
          }}
        >
          <i className="material-icons w3-text-white" style={{ fontSize: 22 }}>
            admin_panel_settings
          </i>
        </div>
        <div style={{ marginRight: 10 }}>
          <div className="w3-text-white" style={{ fontSize: 14, fontWeight: 'bold' }}>
            {admin?.account_name}
          </div>
          <div className="w3-text-light-grey" style={{ fontSize: 11 }}>
            مدیر سیستم
          </div>
        </div>
      </div>

      {/* ساختار درختی منو */}
      <div style={{ flex: 1, overflowY: 'auto', padding: '10px 0' }}>
        {MENU_TREE.map((group) => (
          <div key={group.id}>
            <div
              onClick={() => toggleGroup(group.id)}
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                padding: '12px 16px',
                cursor: 'pointer',
                color: '#B0BEC5'
              }}
              className="w3-hover-blue-grey"
            >
              <div style={{ display: 'flex', alignItems: 'center' }}>
                <i className="material-icons" style={{ fontSize: 20, marginLeft: 10 }}>
                  {group.icon}
                </i>
                <span style={{ fontSize: 14 }}>{group.title}</span>
              </div>
              <i className="material-icons" style={{ fontSize: 18 }}>
                {expandedGroups.includes(group.id) ? 'expand_less' : 'expand_more'}
              </i>
            </div>

            {expandedGroups.includes(group.id) && (
              <div>
                {group.children.map((child) => (
                  <div
                    key={child.id}
                    onClick={() => onNavigate(child.id)}
                    className="w3-hover-blue-grey"
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      padding: '10px 16px 10px 16px',
                      paddingRight: 42,
                      cursor: 'pointer',
                      color: activePage === child.id ? '#4FC3F7' : '#90A4AE',
                      backgroundColor: activePage === child.id ? '#2980b915' : 'transparent',
                      borderRight: activePage === child.id ? '3px solid #4FC3F7' : '3px solid transparent',
                      fontSize: 13
                    }}
                  >
                    <i className="material-icons" style={{ fontSize: 16, marginLeft: 8 }}>
                      {child.icon}
                    </i>
                    {child.title}
                  </div>
                ))}
              </div>
            )}
          </div>
        ))}
      </div>

      {/* دکمه خروج */}
      <div style={{ padding: 16, borderTop: '1px solid #37474F' }}>
        <button
          onClick={logout}
          className="w3-button w3-block"
          style={{
            color: '#ff0000',
            backgroundColor: 'transparent',
            border: '1.5px solid #ff0000',
            borderRadius: '10px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
          }}
        >
          <i className="material-icons w3-margin-left" style={{ fontSize: 18 }}>
            logout
          </i>
          خروج از پنل
        </button>
      </div>
    </div>
  );
};